import React, { FormEvent, useEffect, useState } from 'react';
import {
  Link,
  Redirect,
  RouteComponentProps,
  withRouter,
} from 'react-router-dom';
import InputFieldText from '../../components/input/floating-label/input-field/InputFieldText';
import Button, { ButtonType } from '../../components/button/Button';
import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';
import { confirmRegistry, login } from '../../redux/actions/login';
import { INITIAL_LAYOUT } from '../../components/routes/Routes';
import GridCellWrapper from '../../components/grid-cell-wrapper/GridCellWrapper';

import { clearFailedRequestQueue } from '../../config/401Handler';
import Mautrechner from './mautrechner/Mautrechner';
import { ConfigModel } from '../../models/ConfigModel';

export interface LoginProps {
  login: (nameOrMail: string, password: string) => void;
  confirmRegistry: (token: string) => void;
  isAuthenticated: boolean;
  registrationConfirmed?: boolean;
  config: ConfigModel;
}

const Login = (props: LoginProps & RouteComponentProps) => {
  const token = location.pathname.split('/')[3];

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [showpassword, setShowPassword] = useState('password');
  const [eyeIcon, setEyeIcon] = useState('fas fa-eye');
  const onSubmit = (e?: FormEvent) => {
    props.login(name, password);
    e?.preventDefault();
  };

  useEffect(() => {
    clearFailedRequestQueue();
    if (token) {
      props.confirmRegistry(token);
    }
  }, []);

  const showPassword = () => {
    const pwField = document.getElementById('passwField');

    if (pwField?.getAttribute('type') === 'password') {
      setShowPassword('text');
      setEyeIcon('fas fa-eye-slash');
    } else {
      setShowPassword('password');
      setEyeIcon('fas fa-eye');
    }
    pwField?.setAttribute('type', showpassword);
  };

  return props.isAuthenticated && props.config.loaded ? (
    <Redirect to={INITIAL_LAYOUT} />
  ) : (
    <div className='start'>
      <div className='wrapper-anmeldung'>
        <GridCellWrapper classes='login' label='hier ist das label'>
          <img
            className='login-pic'
            src={process.env.PUBLIC_URL + '/login-pic.png'}
          />
          <div className='login-form'>
            {props.registrationConfirmed ? (
              <h3>E-Mail Adresse bestätigt</h3>
            ) : (
              ''
            )}
            <h2>Log-in</h2>
            <form id={'login'} onSubmit={e => onSubmit(e)}>
              <InputFieldText
                onChangeHandler={setName}
                value={name}
                name={'username'}
                label='Benutzername oder E-Mail-Adresse'
                classes='login-input'
                required={true}
              />

              <InputFieldText
                inputType={showpassword}
                name={'password'}
                id={'passwField'}
                onChangeHandler={setPassword}
                value={password}
                label='Passwort'
                classes='login-input'
                required={true}
              />

              <Button
                classes={'showpassword'}
                tooltip='Passwort anzeigen'
                key={1}
                onClickHandler={() => showPassword()}
              >
                <i className={eyeIcon} />
              </Button>

              <Button type={ButtonType.submit} classes='login-btn'>
                Log-in
              </Button>
              {props.config.isRegistrierung && (
                <Button
                  type={ButtonType.button}
                  classes='login-btn'
                  onClickHandler={() => props.history.push('/register')}
                >
                  Registrierung
                </Button>
              )}
              <Link to='/forgottenPassword'>
                <div className={'forgotten'}>Passwort vergessen</div>
              </Link>
            </form>
          </div>
        </GridCellWrapper>
        {/*{props.config.isMautrechner && <Mautrechner />}*/}
        {<Mautrechner />}
      </div>
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  isAuthenticated: !!state.Auth.accessToken,
  registrationConfirmed: state.Auth.confirmRegistry,
  config: state.Config,
});

export default connect(mapStateToProps, {
  login,
  confirmRegistry,
})(withRouter(Login));
